<div class="bg-light">
  <app-left-menu></app-left-menu>
  <router-outlet></router-outlet>
</div>